import { MutationTypeEnum, QueryTypeEnum } from "@graphapi-io/declarations";
import { GraphQLOperationType } from "./types";

export const hasCreateMutationType = (types: GraphQLOperationType[]) =>
  types.includes(MutationTypeEnum.CREATE);

export const hasUpdateMutationType = (types: GraphQLOperationType[]) =>
  types.includes(MutationTypeEnum.UPDATE);

export const hasDeleteMutationType = (types: GraphQLOperationType[]) =>
  types.includes(MutationTypeEnum.DELETE);

export const hasListQueryType = (types: GraphQLOperationType[]) =>
  types.includes(QueryTypeEnum.LIST);

export const hasListByParentQueryType = (types: GraphQLOperationType[]) =>
  types.includes(QueryTypeEnum.LIST_BY_PARENT);

export const hasObjectQueryType = (types: GraphQLOperationType[]) =>
  types.includes(QueryTypeEnum.OBJECT);

export const toggleResolverTypeAll = (types: GraphQLOperationType[]) => {
  const hasCreate = hasCreateMutationType(types);
  const hasUpdate = hasUpdateMutationType(types);
  const hasDelete = hasDeleteMutationType(types);
  const hasAll = hasCreate && hasUpdate && hasDelete;

  if (hasAll) {
    return [MutationTypeEnum.CREATE];
  }

  return [
    MutationTypeEnum.CREATE,
    MutationTypeEnum.UPDATE,
    MutationTypeEnum.DELETE,
  ];
};

export const togglResolverType = (
  types: GraphQLOperationType[],
  typeToToggle: GraphQLOperationType,
) => {
  const hasToggledType = types.includes(typeToToggle);

  if (hasToggledType) {
    return types.filter((type) => type !== typeToToggle);
  }

  return [...types, typeToToggle];
};
